module.exports = __webpack_public_path__ + "img/teams_crests.eb557995.png";